import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import { Box, Button, Grid, Link, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { Container } from '@mui/system';
import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';

import EmploymentSubMenu from '@/components/nav/EmploymentSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import ExitPopup941 from '@/components/ui/ExitPopup941';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import { getLastDateOfTheMonth } from '@/utils/utils';
// import { getLastDateOfTheMonth } from '@/utils/utils';

const Index = () => {
  const [open, setOpen] = useState(false);

  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 7, 31));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 7, 31)
      );
    }, 1000); // Updates every second (adjust if needed)
  }, []);
  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1.5,
            backgroundColor: '#212121',
            textAlign: 'center',
            minWidth: { xs: 55, sm: 70, md: 70 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 24 },
            fontWeight: 900,
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.5 },
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#fff',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 12 },
            fontWeight: 500,
            color: '#333',
            mt: 0,
            mx: -1.5,
            mb: -1.5,
            py: 0.2,
            px: { xs: 0.5, sm: 1, lg: 0.5 },
            borderRadius: '0px 0px 8px 8px',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Day</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };

  return (
    <AppLayout
      meta={
        <Meta
          title="Simplify Your Form 94X Employment Tax Filing with TaxZerone"
          description="Easily file your Form 94X employment taxes with TaxZerone. File IRS Forms 940, 941, 943, 944, and 945 online quickly and accurately —all in one place."
          keywords="IRS Employment Tax, Form 941, Form 941 Filing Online, IRS Withholding Tax, IRS 94x Forms"
          canonical="employment-tax/"
          jsonLdPricing="6.99"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="54869"
          ogShareImg="assets/images/employment-share-img.png"
        />
      }
    >
      <ExitPopup941 />
      {/* // isPriceView1099s={false}
      // setIsPriceView1099s={function (value: SetStateAction<boolean>): void { */}
      {/* throw new Error('Function not implemented.');
       }} */}

      <EmploymentSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
        component="section"
      >
        <Box
          sx={{
            background: 'linear-gradient(135deg, #458393, #34A99D)',
            p: 1.5,
            px: 2.5,
            color: '#efefef',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Typography
              component="div"
              variant="body1"
              sx={{
                textAlign: { xs: 'center', sm: 'left' },
                fontSize: { xs: 15, sm: 17, md: 18, lg: '1.25rem' },
                color: '#efefef',
                lineHeight: 1.3,
              }}
            >
              <strong> 📢 Deadline Has Passed! </strong> E-file{' '}
              <span style={{ fontWeight: 600, color: '#ffca4d' }}>
                {' '}
                Form 941 (Q2-2026)
              </span>{' '}
              Now to Minimize IRS Penalties.
            </Typography>
            <Box>
              {/* <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  mb: { xs: 1, sm: 1 },
                  lineHeight: 1.3,
                }}
              >
                Time left to file before the deadline{' '}
                <Hidden smUp>
                  <br />
                </Hidden>
                (
                <span style={{ fontWeight: 600, color: '#fff' }}>
                  July 31, 2026
                </span>
                ):
              </Typography> */}
              <Countdown date={lastDayTaxSeason} renderer={renderer} />
            </Box>
            <Box>
              <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=employment`}
                sx={{
                  backgroundColor: '#fff',
                  '&:hover, &:focus': {
                    backgroundColor: '#213e99',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#333',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: { xs: 14, sm: 16, md: 18 },
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                E-File Now!
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container>
      <Box sx={{ maxWidth: 1920, mx: 'auto' }} component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="header"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                E-file{' '}
                <span className="highlight-container">
                  <span className="highlight">Employment Tax Forms</span>
                </span>{' '}
                with the IRS
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                Save time and reduce errors in your employment tax filings with
                our secure and user-friendly e-filing solution.
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Button
                  variant="contained"
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=employment`}
                  sx={{
                    mr: { xs: 0, md: 4 },
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                >
                  Get Started Now
                </Button>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>

              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={0}
                m={0}
                mt={{ xs: 2, md: 5 }}
                pb={0}
                textAlign="center"
                sx={{ ml: { xs: 0, md: -5 } }}
              >
                <Grid size={4}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 4,
                      borderWidth: 0,
                      fontSize: { xs: 9, sm: 12, lg: 13 },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#efefef',
                        borderRadius: '50%',
                        width: { xs: 40, sm: 70 },
                        height: { xs: 40, sm: 70 },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mx: 'auto',
                        mb: { xs: 0.5, sm: 1 },
                        p: { xs: 1, sm: 2 },
                        textAlign: 'center',
                      }}
                    >
                      <picture style={{ width: '100%', height: '100%' }}>
                        <source
                          srcSet="/assets/images/secure-new-icon.webp"
                          width="100%"
                          height="100%"
                        />
                        <source
                          srcSet="/assets/images/secure-new-icon.png"
                          width="100%"
                          height="100%"
                        />
                        <img
                          src="/assets/images/secure-new-icon.png"
                          alt="Safe & Secure"
                          loading="lazy"
                          width="100%"
                          height="100%"
                        />
                      </picture>
                    </Box>
                    <strong>
                      Safe &
                      <Hidden lgUp mdDown>
                        <br />
                      </Hidden>{' '}
                      Secure
                    </strong>
                  </Paper>
                </Grid>
                <Grid size={4}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 4,
                      borderWidth: 0,
                      fontSize: { xs: 9, sm: 12, lg: 13 },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#efefef',
                        borderRadius: '50%',
                        width: { xs: 40, sm: 70 },
                        height: { xs: 40, sm: 70 },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mx: 'auto',
                        mb: { xs: 0.5, sm: 1 },
                        p: { xs: 1, sm: 2 },
                        textAlign: 'center',
                      }}
                    >
                      <picture style={{ width: '100%', height: '100%' }}>
                        <source
                          srcSet="/assets/images/irs-new-icon.webp"
                          width="100%"
                          height="100%"
                        />
                        <source
                          srcSet="/assets/images/irs-new-icon.png"
                          width="100%"
                          height="100%"
                        />
                        <img
                          src="/assets/images/irs-new-icon.png"
                          alt="IRS Authorized"
                          loading="lazy"
                          width="100%"
                          height="100%"
                        />
                      </picture>
                    </Box>
                    <strong>
                      IRS
                      <Hidden lgUp mdDown>
                        <br />
                      </Hidden>{' '}
                      Authorized
                    </strong>
                  </Paper>
                </Grid>
                <Grid size={4}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 1, sm: 2 },
                      borderRadius: 0,
                      borderWidth: 0,
                      fontSize: { xs: 9, sm: 12, lg: 13 },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#efefef',
                        borderRadius: '50%',
                        width: { xs: 40, sm: 70 },
                        height: { xs: 40, sm: 70 },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mx: 'auto',
                        mb: { xs: 0.5, sm: 1 },
                        p: { xs: 1, sm: 2 },
                        textAlign: 'center',
                      }}
                    >
                      <picture style={{ width: '100%', height: '100%' }}>
                        <source
                          srcSet="/assets/images/lowest-new-icon.webp"
                          width="100%"
                          height="100%"
                        />
                        <source
                          srcSet="/assets/images/lowest-new-icon.png"
                          width="100%"
                          height="100%"
                        />
                        <img
                          src="/assets/images/lowest-new-icon.png"
                          alt="Affordable Price"
                          loading="lazy"
                          width="100%"
                          height="100%"
                        />
                      </picture>
                    </Box>
                    <strong>
                      Affordable
                      <Hidden lgUp mdDown>
                        <br />
                      </Hidden>{' '}
                      Filing Fee
                    </strong>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Hidden lgDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
              className="employment-bg"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/employment-tax-img.webp"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <source
                  srcSet="/assets/images/employment-tax-img.png"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <img
                  src="/assets/images/employment-tax-img.png"
                  alt="E-file Employment Tax Forms with the IRS"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden lgUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
              className="employment-bg"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/employment-tax-img-sm.webp"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <source
                  srcSet="/assets/images/employment-tax-img-sm.png"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <img
                  src="/assets/images/employment-tax-img-sm.png"
                  alt="E-file Employment Tax Forms with the IRS"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Box>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          overflow: 'hidden',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="stretch"
            spacing={2}
            m={2}
            mt={5}
            pb={5}
            mb={{ xs: 5, sm: 5 }}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                File Employment Tax Forms Online
                <br />
                with the IRS using TaxZerone
              </Typography>
              {/* <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 0,
                  textAlign: 'center',
                }}
              >
                Choose TaxZerone for simple, quick, and secure e-filing.
              </Typography> */}
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 24, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  Form 941
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, minHeight: 126 }}>
                  Employer&apos;s{' '}
                  <Link
                    href="/employment-tax/e-file-irs-form-941/"
                    sx={{ color: '#0202ff' }}
                  >
                    Quarterly Federal Tax Return
                  </Link>
                  . Report employment taxes paid for the quarter{' '}
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'flex-start' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Only&nbsp;
                      <Typography
                        component="strong"
                        variant="h3"
                        sx={{
                          fontSize: { xs: 28, sm: 32, md: 32 },
                          fontWeight: 700,
                          color: '#0a7581',
                          fontStyle: 'normal',
                        }}
                      >
                        $6.99
                      </Typography>
                    </Typography>
                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=employment`}
                      >
                        E-file Form 941
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/941-2025-img.webp" />
                    <source srcSet="/assets/images/941-2025-img.png" />
                    <img
                      src="/assets/images/941-2025-img.png"
                      alt="Form 941 - Employer's Quarterly Federal Tax Return"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 24, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  Form 941-SP
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, minHeight: 126 }}>
                  {' '}
                  <Link
                    href="/employment-tax/e-file-irs-form-941-sp/"
                    sx={{ color: '#0202ff' }}
                  >
                    Declaración del Impuesto Federal TRIMESTRAL del Empleador.
                  </Link>{' '}
                  Report employment taxes paid for the quarter in Spanish.
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'flex-start' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Only&nbsp;
                      <Typography
                        component="strong"
                        variant="h3"
                        sx={{
                          fontSize: { xs: 28, sm: 32, md: 32 },
                          fontWeight: 700,
                          color: '#0a7581',
                          fontStyle: 'normal',
                        }}
                      >
                        $6.99
                      </Typography>
                    </Typography>
                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=employment`}
                      >
                        E-File Form 941-SP
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/941sp-img.webp" />
                    <source srcSet="/assets/images/941sp-img.png" />
                    <img
                      src="/assets/images/941sp-img.png"
                      alt="Declaración del Impuesto Federal TRIMESTRAL del Empleador."
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 24, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  Form 940
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, minHeight: 126 }}>
                  Employer&apos;s Annual Federal{' '}
                  <Link
                    href="/employment-tax/e-file-irs-form-940/"
                    sx={{ color: '#0202ff' }}
                  >
                    Unemployment (FUTA) Tax Return
                  </Link>
                  . Report your annual Federal Unemployment Tax Act (FUTA)
                  tax.{' '}
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'center' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Only&nbsp;
                      <Typography
                        component="strong"
                        variant="h3"
                        sx={{
                          fontSize: { xs: 28, sm: 32, md: 32 },
                          fontWeight: 700,
                          color: '#0a7581',
                          fontStyle: 'normal',
                        }}
                      >
                        $6.99
                      </Typography>
                    </Typography>

                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=employment`}
                      >
                        E-file Form 940
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/940-img.webp" />
                    <source srcSet="/assets/images/940-img.png" />
                    <img
                      src="/assets/images/940-img.png"
                      alt="940 - Employer's Annual Federal Unemployment ( FUTA ) Tax Return"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 24, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  Form 941 Schedule R
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, minHeight: 126 }}>
                  <Link
                    href="/employment-tax/e-file-irs-form-941-schedule-r/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 941 Schedule R
                  </Link>
                  : Employer&apos;s Quarterly Federal Tax Return Schedule R to
                  report and allocate aggregate employment tax liabilities.
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'center' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Only&nbsp;
                      <Typography
                        component="strong"
                        variant="h3"
                        sx={{
                          fontSize: { xs: 28, sm: 32, md: 32 },
                          fontWeight: 700,
                          color: '#0a7581',
                          fontStyle: 'normal',
                        }}
                      >
                        $9.99
                      </Typography>
                    </Typography>

                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=employment`}
                      >
                        E-File Form 941 Schedule R
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/941sch-r-img.webp" />
                    <source srcSet="/assets/images/941sch-r-img.png" />
                    <img
                      src="/assets/images/941sch-r-img.png"
                      alt="Form 941 Schedule R: Employer's Quarterly Federal Tax Return Schedule R"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 24, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  Form 943
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, minHeight: 126 }}>
                  Employer&apos;s Annual Federal Tax Return for Agricultural
                  Employees. Report{' '}
                  <Link
                    href="/employment-tax/e-file-irs-form-943/"
                    sx={{ color: '#0202ff' }}
                  >
                    employment taxes for farm workers
                  </Link>
                  .
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'center' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Only&nbsp;
                      <Typography
                        component="strong"
                        variant="h3"
                        sx={{
                          fontSize: { xs: 28, sm: 32, md: 32 },
                          fontWeight: 700,
                          color: '#0a7581',
                          fontStyle: 'normal',
                        }}
                      >
                        $6.99
                      </Typography>
                    </Typography>

                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=employment`}
                      >
                        E-File Form 943
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/943-img.webp" />
                    <source srcSet="/assets/images/943-img.png" />
                    <img
                      src="/assets/images/943-img.png"
                      alt="Employer's Annual Federal Tax Return for Agricultural Employees."
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 24, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  Form 944
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, minHeight: 126 }}>
                  Employer&apos;s Annual Federal Tax Return. Report{' '}
                  <Link
                    href="/employment-tax/e-file-irs-form-944/"
                    sx={{ color: '#0202ff' }}
                  >
                    annual employment taxes
                  </Link>{' '}
                  if you qualify for annual filing based on a lower payroll.
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'center' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Only&nbsp;
                      <Typography
                        component="strong"
                        variant="h3"
                        sx={{
                          fontSize: { xs: 28, sm: 32, md: 32 },
                          fontWeight: 700,
                          color: '#0a7581',
                          fontStyle: 'normal',
                        }}
                      >
                        $6.99
                      </Typography>
                    </Typography>

                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=employment`}
                      >
                        E-File Form 944
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/944-img.webp" />
                    <source srcSet="/assets/images/944-img.png" />
                    <img
                      src="/assets/images/944-img.png"
                      alt="Employer’s Annual Federal Tax Return."
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 24, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  Form 945
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, minHeight: 126 }}>
                  Annual Return of Withheld Federal Income Tax. Report{' '}
                  <Link
                    href="/employment-tax/e-file-irs-form-945/"
                    sx={{ color: '#0202ff' }}
                  >
                    income tax withholding on nonpayroll items
                  </Link>
                  .
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'center' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Only&nbsp;
                      <Typography
                        component="strong"
                        variant="h3"
                        sx={{
                          fontSize: { xs: 28, sm: 32, md: 32 },
                          fontWeight: 700,
                          color: '#0a7581',
                          fontStyle: 'normal',
                        }}
                      >
                        $6.99
                      </Typography>
                    </Typography>

                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=employment`}
                      >
                        E-File Form 945
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/945-img.webp" />
                    <source srcSet="/assets/images/945-img.png" />
                    <img
                      src="/assets/images/945-img.png"
                      alt="Annual Return of Withheld Federal Income Tax."
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 24, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  Form 941-X
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, minHeight: 126 }}>
                  Correct mistakes on a previously filed Form 941 and{' '}
                  <Link
                    href="/employment-tax/efile-irs-form-941-x-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    claim a refund or adjust employment taxes
                  </Link>{' '}
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'center' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Only&nbsp;
                      <Typography
                        component="strong"
                        variant="h3"
                        sx={{
                          fontSize: { xs: 28, sm: 32, md: 32 },
                          fontWeight: 700,
                          color: '#0a7581',
                          fontStyle: 'normal',
                        }}
                      >
                        $6.99
                      </Typography>
                    </Typography>

                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=employment`}
                      >
                        E-File Form 941-X
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/941x-img.webp" />
                    <source srcSet="/assets/images/941x-img.png" />
                    <img
                      src="/assets/images/941x-img.png"
                      alt="Correct mistakes on a previously filed Form 941"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 24, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  Form 940 Amendment
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, minHeight: 126 }}>
                  Correct mistakes on previously filed Form 940 and{' '}
                  <Link
                    href="/employment-tax/efile-irs-form-940-amendment/"
                    sx={{ color: '#0202ff' }}
                  >
                    amend your FUTA tax
                  </Link>{' '}
                  information{' '}
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'center' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Only&nbsp;
                      <Typography
                        component="strong"
                        variant="h3"
                        sx={{
                          fontSize: { xs: 28, sm: 32, md: 32 },
                          fontWeight: 700,
                          color: '#0a7581',
                          fontStyle: 'normal',
                        }}
                      >
                        $6.99
                      </Typography>
                    </Typography>

                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=employment`}
                      >
                        File Form 940 Amendment
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/940-img.webp" />
                    <source srcSet="/assets/images/940-img.png" />
                    <img
                      src="/assets/images/940-img.png"
                      alt="940 - Employer's Annual Federal Unemployment ( FUTA ) Tax Return"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 24, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  Form 943-X
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, minHeight: 126 }}>
                  Correct any errors on previously filed Form 943. Used to{' '}
                  <Link
                    href="/employment-tax/e-file-irs-form-943-x/"
                    sx={{ color: '#0202ff' }}
                  >
                    amend the agricultural employment tax return.
                  </Link>{' '}
                  if you qualify for annual filing based on a lower payroll.
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'center' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Only&nbsp;
                      <Typography
                        component="strong"
                        variant="h3"
                        sx={{
                          fontSize: { xs: 28, sm: 32, md: 32 },
                          fontWeight: 700,
                          color: '#0a7581',
                          fontStyle: 'normal',
                        }}
                      >
                        $6.99
                      </Typography>
                    </Typography>

                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=employment`}
                      >
                        E-File Form 943-X
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/943x-img.webp" />
                    <source srcSet="/assets/images/943x-img.png" />
                    <img
                      src="/assets/images/943x-img.png"
                      alt="Correct any errors on previously filed Form 943."
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 24, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  Form 945-X
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, minHeight: 126 }}>
                  Correct errors in a previously filed Form 945. You must{' '}
                  <Link
                    href="/employment-tax/e-file-irs-form-945-x/"
                    sx={{ color: '#0202ff' }}
                  >
                    amend the Annual Return of Withheld Federal Income Tax
                  </Link>{' '}
                  by filing a correction form.
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'center' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Only&nbsp;
                      <Typography
                        component="strong"
                        variant="h3"
                        sx={{
                          fontSize: { xs: 28, sm: 32, md: 32 },
                          fontWeight: 700,
                          color: '#0a7581',
                          fontStyle: 'normal',
                        }}
                      >
                        $6.99
                      </Typography>
                    </Typography>

                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=employment`}
                      >
                        E-File Form 945-X
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/945-x-img.webp" />
                    <source srcSet="/assets/images/945-x-img.png" />
                    <img
                      src="/assets/images/945-x-img.png"
                      alt="Changes required in Employment landing page"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 24, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  Form 94x On-Line Signature PIN
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, minHeight: 96 }}>
                  Apply for{' '}
                  <Link
                    href="/employment-tax/e-file-irs-form-94x-pin-request/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 94x On-Line Signature PIN
                  </Link>{' '}
                  to e-File Employment Tax Forms. Get a 10-digit signature PIN
                  to e-File 94x Tax Forms.{' '}
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'center' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      &nbsp;
                      <Typography
                        component="strong"
                        variant="h3"
                        sx={{
                          fontSize: { xs: 28, sm: 32, md: 32 },
                          fontWeight: 700,
                          color: '#0a7581',
                          fontStyle: 'normal',
                        }}
                      >
                        FREE
                      </Typography>
                    </Typography>

                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=employment`}
                      >
                        Apply 94x PIN
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/94x-img.webp" />
                    <source srcSet="/assets/images/94x-img.png" />
                    <img
                      src="/assets/images/94x-img.png"
                      alt="Form 94x On-Line Signature PIN"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" component="section">
        <Grid
          container
          spacing={2}
          sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
          className="MuiGrid-root-width"
        >
          <Grid size={12} textAlign="center">
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 3,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              How to e-file IRS employment tax forms for
              <br />
              your organization using TaxZerone?
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
                textAlign: 'center',
              }}
            >
              Follow the simple steps below to e-file IRS employment forms.
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="xl" sx={{ mb: 5 }} component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
          sx={{ justifyContent: 'center', alignItems: 'center' }}
        >
          <Box
            component="div"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              width: '100%',
              mt: { xs: -3, md: -5, lg: -8 },
            }}
          >
            <picture>
              <source
                srcSet="/assets/images/employment-steps-img.webp"
                className="img-responsive"
                width={915}
                height={790}
              />
              <source
                srcSet="/assets/images/employment-steps-img.png"
                className="img-responsive"
                width={915}
                height={790}
              />
              <img
                src="/assets/images/employment-steps-img.png"
                alt="How to e-file IRS employment tax forms for your organization using TaxZerone?"
                className="img-responsive"
                loading="lazy"
                width={915}
                height={790}
              />
            </picture>
          </Box>

          <Box
            sx={{
              width: '100%',
            }}
          >
            <Box
              component="ol"
              sx={{
                [`& .${timelineItemClasses.root}:before`]: {
                  flex: 0,
                  padding: 0,
                },
                p: 2,
                pl: 0,
                ml: { xs: 0, sm: 0, md: -2 },
              }}
            >
              <TimelineItem>
                <TimelineSeparator>
                  <TimelineDot
                    sx={{
                      backgroundColor: 'transparent',
                      boxShadow: 'none',
                      my: -1,
                      mb: -1.7,
                    }}
                  >
                    <picture>
                      <source
                        srcSet="/assets/images/step-1-icon.webp"
                        width={39}
                        height={39}
                      />
                      <source
                        srcSet="/assets/images/step-1-icon.png"
                        width={39}
                        height={39}
                      />
                      <img
                        src="/assets/images/step-1-icon.png"
                        alt="Select the form you want to file"
                        loading="lazy"
                        width={39}
                        height={39}
                      />
                    </picture>
                  </TimelineDot>
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent sx={{ mb: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      mt: 0,
                      mb: 1,
                      color: '#36324a',
                    }}
                  >
                    Select the form you want to file
                  </Typography>
                </TimelineContent>
              </TimelineItem>
              <TimelineItem>
                <TimelineSeparator>
                  <TimelineDot
                    sx={{
                      backgroundColor: 'transparent',
                      boxShadow: 'none',
                      m: 0,
                      mt: -1,
                      mb: -1.7,
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/step-2-icon.webp" />
                      <source srcSet="/assets/images/step-2-icon.png" />
                      <img
                        src="/assets/images/step-2-icon.png"
                        alt="Fill out the form information"
                        loading="lazy"
                        width={39}
                        height={39}
                      />
                    </picture>
                  </TimelineDot>
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent sx={{ mb: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      mt: 0,
                      mb: 1,
                      color: '#36324a',
                    }}
                  >
                    Fill out the form information
                  </Typography>
                </TimelineContent>
              </TimelineItem>
              <TimelineItem>
                <TimelineSeparator>
                  <TimelineDot
                    sx={{
                      backgroundColor: 'transparent',
                      boxShadow: 'none',
                      mt: -1,
                      mb: -1.7,
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/step-3-icon.webp" />
                      <source srcSet="/assets/images/step-3-icon.png" />
                      <img
                        src="/assets/images/step-3-icon.png"
                        alt="Review and transmit the form to the IRS"
                        loading="lazy"
                        width={39}
                        height={39}
                      />
                    </picture>
                  </TimelineDot>
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      mt: 0,
                      mb: 1,
                      color: '#36324a',
                    }}
                  >
                    Review and transmit the form to the IRS
                  </Typography>
                </TimelineContent>
              </TimelineItem>
              <TimelineItem>
                <TimelineSeparator>
                  <TimelineDot
                    sx={{
                      backgroundColor: 'transparent',
                      boxShadow: 'none',
                      mt: -1,
                      mb: -1.7,
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/step-4-icon.webp" />
                      <source srcSet="/assets/images/step-4-icon.png" />
                      <img
                        src="/assets/images/step-4-icon.png"
                        alt="Get notified when the IRS accepts your form."
                        loading="lazy"
                        width={39}
                        height={39}
                      />
                    </picture>
                  </TimelineDot>
                </TimelineSeparator>
                <TimelineContent>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      mt: 0,
                      mb: 1,
                      color: '#36324a',
                    }}
                  >
                    Get notified when the IRS accepts your form.
                  </Typography>
                </TimelineContent>
              </TimelineItem>
            </Box>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 21, md: 20, sm: 18, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                textAlign: { xs: 'center', md: 'left' },
              }}
            >
              Ready to file employment taxes online?
            </Typography>
            <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: { xs: 2, sm: 4 },
                  mb: { xs: 2, sm: 2, md: 5 },
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=employment`}
              >
                Get started now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Reasons to choose TaxZerone for employment tax e-filing
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Choose TaxZerone for employment tax e-filing and experience a
                seamless, hassle-free process.
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            m={2}
            mt={4}
            pb={{ xs: 0, sm: 4, md: 7 }}
            sx={{ justifyContent: 'center', p: 0, listStyleType: 'none' }}
            component="ul"
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/easy-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/easy-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/easy-icon.png"
                      alt="Easy e-filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Easy e-filing
                </Typography>
                <Typography variant="body1">
                  An intuitive and user-friendly platform that makes e-filing
                  employment taxes simple and easy. Complete your filings
                  quickly and accurately, even if you&apos;re not a tax expert.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/guided-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/guided-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/guided-icon.png"
                      alt="Guided filing interface"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Guided filing interface
                </Typography>
                <Typography variant="body1">
                  We&apos;ll walk you through every step, prompting you for the
                  necessary information and eliminating any guesswork.
                  You&apos;ll feel confident knowing you&apos;re completing your
                  tax filings correctly.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/smart-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/smart-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/smart-icon.png"
                      alt="Smart IRS validations"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Smart IRS validations
                </Typography>
                <Typography variant="body1">
                  Our system automatically checks your return for errors and
                  inconsistencies and helps you avoid costly errors and IRS
                  penalties. You can file with confidence, knowing your
                  information is accurate.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12} component="li">
                &nbsp;
              </Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/secure-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/secure-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/secure-icon.png"
                      alt="Quick & secure"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Quick & secure
                </Typography>
                <Typography variant="body1">
                  Experience a fast e-filing process and a secure environment.
                  Stay assured that your data is protected through advanced
                  encryption and security measures.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/instant-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/instant-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/instant-icon.png"
                      alt="Instant IRS updates"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Instant IRS updates
                </Typography>
                <Typography variant="body1">
                  You&apos;re always in the know. No more waiting anxiously for
                  confirmation. We keep you informed every step of the way.
                  You&apos;ll receive notifications as soon as the IRS processes
                  your return.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/free-efile-retransmission-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/free-efile-retransmission-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/free-efile-retransmission-icon.png"
                      alt="Free retransmission of rejected returns"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Free retransmission of rejected returns
                </Typography>
                <Typography variant="body1">
                  If your employment tax return is rejected, don&apos;t worry –
                  we offer free retransmission. We&apos;ll help you identify and
                  correct the issues and ensure your filings are accepted
                  without additional charges.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
        component="section"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            lineHeight: 1.5,
            mb: 3,
          }}
        >
          Ready to Simplify Your Employment Tax Filing?
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            lineHeight: 1.5,
            mb: 3,
          }}
        >
          File your employment taxes quickly and confidently. Get started now
          and experience the TaxZerone advantage.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=employment`}
          >
            Get Started Now
          </Button>
        </Box>
      </Box>

      <Container
        maxWidth="lg"
        component="section"
        aria-labelledby="employment-tax-faqs"
      >
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              id="employment-tax-faqs"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What is employment tax, and who is required to file it?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="p" itemProp="text">
                    Employment tax includes Social Security, Medicare, and
                    federal income taxes withheld from employees&apos; wages.
                    Employers are required to file employment tax returns if
                    they have employees.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Can I e-file employment tax returns with the IRS?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1">
                      Yes, the IRS also recommends e-filing of employment tax
                      returns. You can e-file tax returns using IRS-authorized
                      e-file providers like TaxZerone.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What forms do I need to use for employment tax filing?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="p" itemProp="text">
                    Employers typically use{' '}
                    <Link
                      href="/resources/employment-tax/form-941-instructions/"
                      sx={{ color: '#0202ff' }}
                    >
                      Form 941
                    </Link>{' '}
                    (Employer&apos;s Quarterly Federal Tax Return) to report
                    employment taxes. However, some smaller employers may use{' '}
                    <Link
                      href="/resources/employment-tax/form-944-instructions/"
                      sx={{ color: '#0202ff' }}
                    >
                      Form 944
                    </Link>{' '}
                    (Employer&apos;s Annual Federal Tax Return) if eligible.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Index;
